module.exports = __webpack_public_path__ + "static/media/add-logo-tablet-es.99d37ab4.png";